import React from "react";
import { Button, CircularProgress } from "@material-ui/core";
import { IAppButtonProps } from "./../../../interfaces";
const AppButton = ({
  isLoading,
  text,
  disabled,
  className,
  ...restProps
}: IAppButtonProps) => (
  <Button
    className={`form-input ${className ? className : ""}`}
    variant="contained"
    disabled={isLoading || disabled}
    {...restProps}
  >
    {isLoading ? (
      <>
        <CircularProgress size={16} color="inherit" />
        &nbsp;&nbsp;{" "}
      </>
    ) : null}
    {text || "Save changes"}
  </Button>
);

export default AppButton;
